<ng-container *ngIf="!selectedItemsSize">
  <div class="list-name-container">
    <div *ngIf="loading" class="loading-container">
      <div class="cc-icon cc-icon-spinner-lg"></div>
      <strong>Loading...</strong>
    </div>
    <div class="list-name-input-container" [class.editable]="!listIsDeployed && hasPermissionToEdit">
      <div class="input-sizer" [class.editable]="!listIsDeployed && hasPermissionToEdit">
        <input
          #listNameInput
          [class.sm-hidden]="loading"
          type="text"
          rows="1"
          class="list-name"
          [class.editable]="!listIsDeployed && hasPermissionToEdit"
          [class.readonly]="listIsDeployed || !hasPermissionToEdit"
          [readonly]="listIsDeployed || !hasPermissionToEdit"
          placeholder="Type list name..."
          [value]="list?.name || ''"
          (change)="updateListName($event.target.value)"
          [title]="list?.name || ''"
          (input)="updateInputSize($event.target)"
          (keyup.esc)="onEscapePress()"
        />
      </div>
      <em
        class="edit-icon cc-icon cc-icon-pencil"
        [class.sm-hidden]="loading"
        (click)="listNameInput.focus()"
        title="Edit list name"
      ></em>
    </div>
  </div>

  <cc-limits-counter
    data-test="limits-counter"
    [itemsCount]="list?.properties?.length"
    [planType]="folder?.planType"
    [limits]="planTypeLimits[dashpivotModules.Lists].properties"
    [context]="dashpivotModules.Lists"
    [stylingChangesOnHover]="true"
  ></cc-limits-counter>

  <div class="sm-flex">
    <span class="updating-list" *ngIf="updating">
      <i class="cc-icon cc-icon-spinner-lg"></i>
      <span>Updating...</span>
    </span>
    <cc-dropdown
      placement="bottom-left auto"
      [autoClose]="true"
      focusOnOpen="none"
      toggleButtonClass="sm-flex sm-items-center"
      [disabled]="!canAddNewItem"
      data-test="import-dropdown-button"
    >
      <div class="control-button" [disabled]="!canAddNewItem" trigger dropdownToggle>
        <i class="cc-icon cc-icon-upload"></i>
        <span i18n>Upload CSV</span>
        <i class="cc-icon cc-icon-arrow-down-small"></i>
      </div>

      <cc-dropdown-item dropdownItem>
        <cc-tool-tip
          placement="left"
          contentText="This option will allow you to upload a CSV with a limit of 5000 list items."
          containerClass="sm-w-full"
        >
          <div class="sm-p-1" (click)="uploadList()" data-test="import-list-rows" trigger>
            <span i18n>List Items only</span>
          </div>

          <input
            #fileUploadInput
            type="file"
            name="file"
            data-test="file-upload-input"
            class="sm-hidden"
            (change)="onFileUpload($event.target.files); $event.target.value = null"
            accept="text/csv"
          />
        </cc-tool-tip>
      </cc-dropdown-item>

      <cc-dropdown-item dropdownItem *ngIf="!listIsDeployed">
        <cc-tool-tip
          placement="left"
          contentText="This option will allow you to upload a CSV with a limit of 200 list items and properties."
          containerClass="sm-w-full"
        >
          <div
            class="sm-flex sm-p-1 sm-items-center sm-gap-1 test"
            (click)="openNewImportModal()"
            data-test="import-list-with-properties"
            trigger
          >
            <span i18n>List Items and properties</span>
            <cc-badge text="Beta" type="info" class="sm-mx-1" textSize="sm-text-xs"></cc-badge>
          </div>
        </cc-tool-tip>
      </cc-dropdown-item>
    </cc-dropdown>

    <button
      type="button"
      trigger
      [disabled]="!canAddNewItem || !list?.items?.length"
      class="control-button"
      data-test="download-csv-button"
      (click)="downloadList()"
    >
      <i class="cc-icon cc-icon-download"></i>
      <span i18n>Download CSV</span>
    </button>

    <button type="button" [disabled]="!canAddNewItem" class="add-item-button" (click)="addListItem()">
      Add Item
    </button>
  </div>
</ng-container>

<div class="multiple-selection-controls" *ngIf="selectedItemsSize">
  <button type="button" (click)="onExportItems()">
    <i class="cc-icon cc-icon-download sm-text-default-text"></i>
    <span i18n>Download</span>
  </button>

  <button type="button" (click)="onStartBulkApplyItemColour()" *ngIf="!listIsDeployed">
    <i class="cc-icon cc-icon-pencil sm-text-default-text"></i>
    <span i18n>Apply Colour</span>
  </button>

  <button type="button" (click)="onDeleteItems()">
    <i class="cc-icon cc-icon-delete sm-text-default-red"></i>
    <span i18n>Delete</span>
  </button>
</div>
